import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const CreateContract = () => {
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);
  const { token } = useContext(AuthContext);

  const [curriculums, setCurriculums] = useState([]);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [areas, setAreas] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [costCenters, setCostCenters] = useState([]);//centro de costos

  const [formData, setFormData] = useState({
    id_curriculum: "",
    type_contract: "",
    job_position: "",
    program: "",
    area: "",
    functions: "",
    salary: "",
    start_date: "",
    end_date: "",
    final_observation: ""
  });

  // ============================
  //   CARGAR CURRICULUMS
  // ============================
  useEffect(() => {
    const fetchCurriculums = async () => {
      try {
        const response = await fetch(ENDPOINTS.getCurriculum, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const result = await response.json();

        if (result.success) {
          setCurriculums(result.data);
        } else {
          setError("Error al cargar curriculum: " + result.message);
        }
      } catch (error) {
        console.error("Error:", error);
        setError("Error al conectar con el servidor");
      }
    };

    fetchCurriculums();
  }, [token]);


  const curriculumOptions = curriculums.map((c) => ({
  value: c.Id, // lo que se envía al backend
  label: `${c.document} - ${c.first_name} ${c.last_name}`, // lo visible
}));

  // ============================
  //   CARGAR CENTRO DE COSTOS
  // ============================


  useEffect(() => {
    const fetchCostCenters = async () => {
      try {
        const res = await authFetch(ENDPOINTS.getCostCenterActive, {
          method: "GET"
        });

        if (res.success) {
          setCostCenters(res.data);
        } else {
          console.error(res.message);
        }

      } catch (err) {
        console.error("Error cargando centros de costo", err);
      }
    };

    fetchCostCenters();
  }, [authFetch]);


  // ============================
  //   HANDLER DEL FORMULARIO
  // ============================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ============================
  //   ENVIAR FORMULARIO
  // ============================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const payload = { ...formData };

      // Convertir end_date vacío a null
      if (payload.end_date === "") {
        payload.end_date = null;
      }

      const response = await fetch(ENDPOINTS.createContract, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      setLoading(false);

      if (result.success) {
        setSuccess("Contrato creado exitosamente");

        setFormData({
          id_curriculum: "",
          type_contract: "",
          job_position: "",
          program: "",
          area: "",
          functions: "",
          salary: "",
          start_date: "",
          end_date: "",
          final_observation: ""
        });
      } else {
        setError(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Error al crear contrato");
      setLoading(false);
    }
  };

// GET AREAS
useEffect(() => {
  const fetchAreas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getarea, {
        method: "GET"
      });

      if (res.success) {
        setAreas(res.data);
      } else {
        console.error(res.message);
      }

    } catch (err) {
      console.error("Error cargando áreas", err);
    }
  };

  fetchAreas();
}, [authFetch]);

  // GET PROGRAMAS
useEffect(() => {
  const fetchProgramas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getprograma, {
        method: "GET"
      });

      if (res.success) {
        setProgramas(res.data);
      } else {
        console.error(res.message);
      }

    } catch (err) {
      console.error("Error cargando programas", err);
    }
  };

  fetchProgramas();
}, [authFetch]);

  return (
    <div className="container mt-4">

      {/* ENCABEZADO IDENTICO A CreateUser */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Crear contrato</h3>
        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/contract_gh/contract")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTAS IGUALES */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* FILA 1: HOJA DE VIDA + TIPO DE CONTRATO */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Colaborador (Hoja de vida) *</label>
            <Select
              options={curriculumOptions}
              placeholder="Buscar colaborador..."
              isClearable
              value={
                curriculumOptions.find(
                  (opt) => opt.value === formData.id_curriculum
                ) || null
              }
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  id_curriculum: selected ? selected.value : "",
                }))
              }
            />

          </div>

          <div className="col-md-6 mb-3">
            <label>Tipo de contrato *</label>
            <select
              name="type_contract"
              className="form-select"
              value={formData.type_contract}
              onChange={handleChange}
            >
              <option value="" hidden>Seleccione...</option>
              <option value="Fijo">Fijo</option>
              <option value="Indefinido">Indefinido</option>
              <option value="Prestacion de servicios">Prestación de servicios</option>
              <option value="Obra labor">Obra labor</option>
            </select>
          </div>
        </div>

        {/* FILA 2: CARGO + PROGRAMA */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Cargo *</label>
            <input
              type="text"
              name="job_position"
              className="form-control"
              value={formData.job_position}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Programa *</label>
              <select
              name="program"
              className="form-select"
              value={formData.program}
              onChange={handleChange}
            >
              <option value=""hidden>Selecciona...</option>

              {programas.map((programa) => (
                <option key={programa.id} value={programa.id}>
                  {programa.name}
                </option>
              ))}

            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label>Área *</label>
            <select
              name="area"
              className="form-select"
              value={formData.area}
              onChange={handleChange}
            >
              <option value=""hidden>Selecciona...</option>

              {areas.map((area) => (
                <option key={area.id_area} value={area.id_area}>
                  {area.name}
                </option>
              ))}

            </select>
      
          </div>
            <div className="col-md-6 mb-3">
            <label>Funciones *</label>
            <textarea
              name="functions"
              className="form-control"
              value={formData.functions}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* FILA 3: SALARIO + CENTRO DE COSTOS */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Salario *</label>
            <input
              type="number"
              name="salary"
              className="form-control"
              value={formData.salary}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Centro de Costos *</label>
            <Select
                options={costCenters.map(cc => ({
                  value: cc.id,
                  label: `${cc.cost_center} - ${cc.name_cost_center} - ${cc.type_cost_center}`
                }))}
                placeholder="Seleccionar centro de costo..."
                onChange={(selected) =>
                  setFormData(prev => ({
                    ...prev,
                    cost_center: selected ? selected.value : ""
                  }))
                }
              />
          </div>


        </div>

        {/* FILA 4: FECHA INICIO-FIN */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Fecha de inicio *</label>
            <input
              type="date"
              name="start_date"
              className="form-control"
              value={formData.start_date}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Fecha de finalización (Opcional)</label>
            <input
              type="date"
              name="end_date"
              className="form-control"
              value={formData.end_date}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* BOTÓN IGUAL AL DE CreateUser */}
        <button
          type="submit"
          className="btn btn-outline-pink w-100"
          disabled={loading}
        >
          {loading ? "Creando..." : "Crear Contrato"}
        </button>
      </form>
    </div>
  );
};

export default CreateContract;
